document.addEventListener('turbo:load', function() {
  var form = document.getElementById('smart-search-form');
  var idInput = document.getElementById('smart-search-record-id');

  if (form && idInput) {
    idInput.focus();
    form.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        form.submit();
      }
    });
  }

  var results = document.getElementById('smart-search-results');
  if (!results) return;

  var sectionUrl = results.dataset.sectionUrl;
  var recordType = results.dataset.recordType;
  var recordId = results.dataset.recordId;
  var navItems = results.querySelectorAll('[data-section-target]');
  var panels = results.querySelectorAll('.smart-search-section-panel');
  var mobileSelect = document.getElementById('smart-search-section-select');
  var activeSectionKey = null;

  function panelForKey(sectionKey) {
    return results.querySelector('.smart-search-section-panel[data-section-key="' + sectionKey + '"]');
  }

  function setPanelLoading(panel, isLoading) {
    var loading = panel.querySelector('.smart-search-section-loading');
    if (loading) loading.classList.toggle('d-none', !isLoading);
  }

  function showSection(sectionKey, options) {
    options = options || {};
    var forceReload = options.forceReload || false;

    navItems.forEach(function(item) {
      item.classList.toggle('active', item.getAttribute('data-section-target') === sectionKey);
    });

    panels.forEach(function(panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-section-key') === sectionKey);
    });

    if (mobileSelect && mobileSelect.value !== sectionKey) {
      mobileSelect.value = sectionKey;
    }

    activeSectionKey = sectionKey;
    var panel = panelForKey(sectionKey);
    if (!panel) return;

    var body = panel.querySelector('.smart-search-section-body');
    if (!body) return;

    if (body.dataset.loaded === 'true' && !forceReload) return;

    loadSection(panel, sectionKey, 1, false);
  }

  function loadSection(panel, sectionKey, page, append) {
    var body = panel.querySelector('.smart-search-section-body');
    var content = panel.querySelector('.smart-search-section-content');
    var empty = panel.querySelector('.smart-search-section-empty');
    var errorBox = panel.querySelector('.smart-search-section-error');
    var loadMore = panel.querySelector('.smart-search-load-more');

    setPanelLoading(panel, true);
    errorBox.classList.add('d-none');

    var url = new URL(sectionUrl, window.location.origin);
    url.searchParams.set('record_type', recordType);
    url.searchParams.set('record_id', recordId);
    url.searchParams.set('section_key', sectionKey);
    url.searchParams.set('page', page);

    fetch(url.toString(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.error || 'Failed to load section');
          return data;
        });
      })
      .then(function(data) {
        setPanelLoading(panel, false);
        if (loadMore) loadMore.disabled = false;
        body.dataset.loaded = 'true';
        body.dataset.page = data.page;

        if (append) {
          content.insertAdjacentHTML('beforeend', data.html);
        } else {
          content.innerHTML = data.html;
        }

        var hasEntities = content.children.length > 0;
        content.classList.toggle('d-none', !hasEntities);
        empty.classList.toggle('d-none', hasEntities);

        if (data.has_more) {
          loadMore.classList.remove('d-none');
          loadMore.onclick = function() {
            loadMore.disabled = true;
            loadSection(panel, sectionKey, data.page + 1, true);
          };
        } else {
          loadMore.classList.add('d-none');
          loadMore.onclick = null;
        }
      })
      .catch(function(error) {
        setPanelLoading(panel, false);
        if (loadMore) loadMore.disabled = false;
        errorBox.textContent = error.message;
        errorBox.classList.remove('d-none');
      });
  }

  navItems.forEach(function(item) {
    item.addEventListener('click', function() {
      showSection(item.getAttribute('data-section-target'));
    });
  });

  if (mobileSelect) {
    mobileSelect.addEventListener('change', function() {
      showSection(mobileSelect.value);
    });
  }

  if (navItems.length > 0) {
    showSection(navItems[0].getAttribute('data-section-target'));
  }
});
